<template>
  <div class="inlineBlock sd-input-munber__range">
    <sd-input-number
      w="150"
      name="min"
      v-model="min"
      :precision="precision || 0"
      @change="handleMinChange"
    />
    <span class="mid-lable">至</span>
    <sd-input-number
      w="150"
      name="max"
      v-model="max"
      :precision="precision || 0"
      @change="handleMaxChange"
    />
  </div>
</template>


<script>
export default {
  name: 'sd-input-number-range',
  props: {
    precision: {
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      min: undefined,
      max: undefined
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newVal) {
        const copyVal = (newVal || []).slice();
        this.min = copyVal.shift() || undefined;
        this.max = copyVal.shift() || undefined;
      }
    }
  },
  methods: {
    calculateFinalValue() {
      const { min, max } = this;
      if (isNaN(min) && isNaN(max)) {
        return [];
      }
      if (Number(min) >= 0 && isNaN(max)) {
        return [min, null];
      }
      if (Number(max) >= 0 && isNaN(min)) {
        return [null, max];
      }
      return [min, max];
    },
    handleMinChange(val) {
      const max = this.max;
      if (isNaN(max)) {
        this.min = val;
        this.trigger();
      } else {
        setTimeout(() => {
          this.min = val >= max ? undefined : val;
          this.trigger();
        });
      }
    },
    handleMaxChange(val) {
      const min = this.min;
      if (isNaN(min)) {
        this.max = val;
        this.trigger();
      } else {
        setTimeout(() => {
          this.max = val <= min ? undefined : val;
          this.trigger();
        });
      }
    },
    trigger() {
      const finalVal = this.calculateFinalValue();
      this.$emit("input", finalVal);
    }
  }
};
</script>

<style lang="scss">
.sd-input-munber__range {
  .mid-lable {
    font-size: 14px;
    color: #606266;
  }
}
</style>


// WEBPACK FOOTER //
// SdInputNumberRange.vue?3c96b108